export enum DocumentActions {
  EditDocument = 'document:EditDocument',
  ViewDocument = 'document:ViewDocument',
  SignDocument = 'document:SignDocument',
}
